'use strict';

angular.module('dekky.forms.themes.bootstrap')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/bootstrap/fields/select.html',
		'<select class="form-control" ng-model="model" name="{{ field.name }}" id="{{ field.name }}">' +
			'<option ng-repeat="item in field.items" value="{{ item[field.selectOptions.value] }}">{{ item[field.selectOptions.label] }}</option>' +
		'</select>'
	);
});